export const getInventoryBadgeColor = type => {
  switch (type) {
    case 'a':
      return 'success';

    case 'b':
      return 'primary';

    case 'c':
      return 'danger';

    case 'missing':
      return 'warning';

    default:
      return 'secondary';
  }
};

export const getInventoryHistoryMethodBadgeColor = method => {
  switch (method) {
    case 'increase':
      return 'primary';

    case 'force_update':
      return 'danger';

    case 'decrease':
      return 'success';

    case 'allocate':
      return 'primary';

    case 'consume':
      return 'primary';

    case 'create':
      return 'success';

    case 'deallocate':
      return 'danger';

    default:
      return 'secondary';
  }
};
